import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "tick--circle",
  "use": "tick--circle-usage",
  "viewBox": "0 0 18.763 18.77",
  "content": "<symbol viewBox=\"0 0 18.763 18.77\" id=\"tick--circle\"><path d=\"M9.375 0a9.36 9.36 0 0 0-6.637 2.736c-3.65 3.645-3.65 9.614 0 13.261a9.277 9.277 0 0 0 6.624 2.773 9.456 9.456 0 0 0 6.651-2.748 9.305 9.305 0 0 0 2.75-6.643 9.345 9.345 0 0 0-2.75-6.643A9.36 9.36 0 0 0 9.375 0zm5.213 14.598c-1.437 1.436-3.331 2.154-5.225 2.154s-3.788-.718-5.225-2.154c-2.875-2.871-2.875-7.567 0-10.439 2.875-2.873 7.575-2.873 10.45 0a7.332 7.332 0 0 1 2.174 5.22 7.33 7.33 0 0 1-2.174 5.219zm-2.86-8.847l1.438 1.439-5.324 5.561L5 9.902l1.439-1.439 1.397 1.405 3.892-4.117z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./application/components/dumb/icon/src/tick--circle.svg
// module id = 190
// module chunks = 0